import { apiFetch } from "@/utils";

function getAllMembersHierarchy(level = -1, excludebel = false) {
  return new Promise((resolve, reject) => {
    apiFetch("member/hierarchy?excludebel=" + excludebel + (level != -1 ? ("&level=" + level) : "")).then(res => {
      const lvLabels = ["A", "G", "SG", "SOC", "PDV"]
      const result = res.map(m => ({
        ...m,
        Label: "[" + lvLabels[m.Level] + "] " + (m.Level > 2 ? ("[" + m.SousGroupeName + "] ") : "") + m.Name + " - " + m.IdCompta + " (" + m.PostalCode + " " + m.City + ")"
      }));
      resolve(result);
    }).catch(reject)
  })
}

function getSocSaisiePrevi() {
  return apiFetch("member/soc-saisie-previ");
}

function getAdhNewsletterData(adhGuid) {
  return apiFetch("newsletter/single?adhGuid=" + adhGuid, true);
}

function getAdhCaRfaHistory(adhGuid) {
  return apiFetch("newsletter/single/history?adhGuid=" + adhGuid, true);
}

function toggleSocSaisiePrevi(socGuid) {
  return apiFetch("member/toggle-soc-saisie-previ?socGuid=" + socGuid);
}

function getSocSaisieHR() {
  return apiFetch("member/soc-saisie-hr");
}

function toggleSocSaisieHR(socGuid) {
  return apiFetch("member/toggle-soc-saisie-hr?socGuid=" + socGuid);
}

export default {
  getAllMembersHierarchy,
  getSocSaisiePrevi,
  toggleSocSaisiePrevi,
  getSocSaisieHR,
  toggleSocSaisieHR,
  getAdhNewsletterData,
  getAdhCaRfaHistory
}
export {
  getAllMembersHierarchy,
  getSocSaisiePrevi,
  toggleSocSaisiePrevi,
  getSocSaisieHR,
  toggleSocSaisieHR,
  getAdhNewsletterData,
  getAdhCaRfaHistory
}



// WEBPACK FOOTER //
// ./src/utils/member.js